import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Activities from "./pages/Activities";
import Gallery from "./pages/GalleryMarquee";
import Contact from "./pages/Contact";
import CreateActivity from "./pages/admin/CreateActivity";
import UploadImage from "./pages/admin/UloadImage";
import MainLayout from "./layouts/Mainlayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/activities" element={<Activities />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/contact" element={<Contact />} />
        <Route
          path="/admin/create"
          element={
            <MainLayout>
              <CreateActivity />
            </MainLayout>
          }
        />
        <Route
          path="/admin/upload"
          element={
            <MainLayout>
              <UploadImage />
            </MainLayout>
          }
        />
      </Routes>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme="light"
        toastClassName="bg-white/80 backdrop-blur-lg text-green-900 rounded-xl"
      />
    </BrowserRouter>
  );
}

export default App;